<template>
  <section
    class="d-flex justify-content-center align-items-end pb-9"
    :class="$style.footer"
    :style="{
      backgroundImage: `url(${assets.FooterBackground.default})`,
    }"
  >
    <JoinButton :href="assets.LINK_TO_CREATOR">
      {{ $t('join.section.footer.cta.label') }}
    </JoinButton>
  </section>
</template>

<script lang="ts">
import { JoinBaseComponent } from '../common/JoinBaseComponent';
import JoinButton from '../common/join-button.vue';
import { FooterBackground } from '../assets/media';

export default JoinBaseComponent.extend({
  components: {
    JoinButton,
  },
  data() {
    return {
      assets: {
        LINK_TO_CREATOR: 'https://creator.viddsee.com',
        FooterBackground,
      },
    };
  },
});
</script>

<style module lang="scss">
@import '~@/scripts/pages/onepager/styles/variables-entry';

.footer {
  position: relative;
  height: 570px;

  background-size: cover;
  background-position: center;
}
</style>
